// extracted by mini-css-extract-plugin
export var breadcrumb = "_7-0";
export var breadcrumbArrow = "_7-1";